import { Injectable } from '@angular/core';
import { snackbarService } from '@one/web-components';


@Injectable({
    providedIn: 'root'
})
export class SnackBarService {

    constructor() { }

    showSnackBar(message: string, status: 'positive' | 'alert' | 'warning', duration: number = 5000) {
        snackbarService.show({
            message,
            snackbarProps: {
                duration,
                showClose: true,
                status,
                variant: 'secondary',
                direction: 'horizontal'
            }
        })
    }

    displaySnackBar(text: string, status: 'positive' | 'alert' | 'warning', duration: number = 5000) {
        return this.showSnackBar(text, status, duration);
    }

}
